{
  "noSitesHint": "The map is built from the site's nodes. Create a site under Sites, then install an agent on it.",
  "narrowViewOnly": "narrow screen — view only",
  "nothingSelected": "Nothing selected",
  "nothingSelectedHint": "Pick a node to see its properties and monitors, or a link to change its line or break it.",
  "newFrameName": "New group",
  "newNodeName": "New node",
  "exportFallbackName": "map",
  "savedOnBlur": "saved when the field loses focus",
  "mode": {
    "view": "View",
    "edit": "Edit"
  },
  "panel": {
    "link": "Link",
    "properties": "Properties",
    "hide": "Hide the properties panel",
    "hideTitle": "Hide the properties panel — the map gets the whole screen",
    "show": "Show the properties panel"
  },
  "minimap": {
    "show": "Show the minimap",
    "hide": "Hide the minimap",
    "hideAria": "Hide the minimap. Bring it back with the button on the map toolbar"
  },
  "grid": {
    "show": "Show the grid",
    "showDots": "Show the grid dots",
    "hideDots": "Hide the grid dots",
    "step": "Grid step",
    "stepHint": "Grid step: nodes snap to it. Remembered per site",
    "stepForbidden": "The grid step is changed by someone with permission for the site"
  },
  "search": {
    "placeholder": "search",
    "aria": "Search the map: name or address",
    "title": "Search by name or address; Enter jumps to the match",
    "jump": "Jump to the match (Enter)",
    "none": "none"
  },
  "filter": {
    "onlyDown": "down",
    "onlyDownHint": "Show only the nodes that are not answering",
    "allKinds": "all types",
    "kindHint": "Show only the selected type"
  },
  "add": {
    "node": "Node",
    "group": "Group",
    "groupTitle": "Add a group"
  },
  "undo": "Undo",
  "undoTitle": "Undo (Ctrl+Z)",
  "redo": "Redo",
  "redoTitle": "Redo (Ctrl+Shift+Z)",
  "saveLayoutTitle": "Save the layout (Ctrl+S)",
  "save": {
    "pressSave": "Press “Save”",
    "dirty": "unsaved: {{what}}",
    "saving": "saving…",
    "failed": "not saved",
    "saved": "saved {{at}}"
  },
  "export": {
    "title": "Export the map",
    "button": "Export",
    "png": "image for a report",
    "svg": "vector diagram",
    "csv": "device list"
  },
  "layers": {
    "title": "Map layers",
    "short": "Layers",
    "buttonHint": "Map layers: what is visible and where new nodes land",
    "showAll": "show all",
    "show": "Show the layer",
    "hide": "Hide the layer",
    "showAria": "Show layer {{name}}",
    "hideAria": "Hide layer {{name}}",
    "solo": "Show only this layer",
    "soloAria": "Show only layer {{name}}",
    "restoreAll": "Bring back all layers",
    "makeActive": "Put new nodes on this layer",
    "rename": "Rename",
    "renameAria": "Rename layer {{name}}",
    "namePrompt": "Layer name",
    "deleteAria": "Delete layer {{name}}",
    "deleteHint": "Delete the layer. A non-empty layer cannot be deleted",
    "newLayer": "New layer",
    "newLayerAria": "Name of the new layer"
  },
  "color": {
    "default": "default",
    "green": "green",
    "yellow": "yellow",
    "red": "red",
    "blue": "blue"
  },
  "group": {
    "expand": "Expand the group",
    "collapse": "Collapse the group",
    "collapsedPrefix": "collapsed · "
  },
  "frame": {
    "empty": "empty",
    "color": "Color",
    "fill": "Fill",
    "noFill": "no fill",
    "fillAria": "Fill: {{color}}",
    "fillOpacity": "Fill opacity",
    "pickFillFirst": "pick a fill color first",
    "insideFrame": "Inside a frame",
    "standalone": "on its own",
    "layerAria": "Frame layer",
    "layerHint": "The frame moves to the layer together with everything inside it",
    "layerFromParent": "A nested frame moves together with its parent",
    "movesWithContent": "everything inside moves with the frame",
    "movesWithParent": "a nested frame moves together with its parent",
    "layerIsHidden": "this layer is hidden right now — the frame will not be visible",
    "delete": "Delete the frame",
    "help": "A node enters a frame by being dragged in, and leaves the same way. Clicking the header collapses the frame, and it stays collapsed after a reload.",
    "readonlyName": "frame: {{name}}",
    "readonlyLayer": "layer: {{name}}",
    "readonlyNodes": "nodes inside: {{count}}",
    "readonlyFill": "fill: {{color}} · {{percent}} %"
  },
  "link": {
    "line": "Line",
    "routingLabel": "Routing",
    "label": "Label",
    "labelPlaceholder": "uplink, 1 Gbit/s",
    "straighten": "Remove the bends ({{count}})",
    "delete": "Break the link",
    "help": "A double click on a selected line adds a bend, dragging moves it, and a double click on the bend itself removes it. A link can also be broken with the Delete key while it is selected on the map.",
    "readonlyStyle": "line: {{style}}",
    "readonlyRouting": "routing: {{routing}}",
    "readonlyLabel": "label: {{label}}",
    "style": {
      "solid": "solid",
      "dashed": "dashed",
      "dotted": "dotted"
    },
    "routing": {
      "step": "step",
      "bezier": "curve",
      "straight": "straight"
    }
  },
  "menu": {
    "connectVnc": "Connect over VNC",
    "openTerminal": "Open a terminal",
    "noVncPermission": "No permission to connect to this node",
    "noSshPermission": "No permission to open a terminal on this node",
    "deleteHint": "Delete the node together with its monitors. Undo cannot bring it back",
    "deleteInEditMode": "Deleting is available in edit mode",
    "noWritePermission": "No permission to change the map"
  },
  "delete": {
    "and": " and ",
    "oneNode": "node “{{name}}”",
    "manyNodes": "{{count}} nodes",
    "oneFrame": "frame “{{name}}”",
    "manyFrames": "{{count}} frames",
    "nodeConsequence": "The monitors will be turned off and the check history stays with the deleted node. Undo cannot bring the node back.",
    "frameConsequence": "The nodes inside the frame stay on the map.",
    "question": "Delete {{what}}? {{consequences}}"
  },
  "history": {
    "linkWaypoint": "link bend",
    "moveFrame": "frame move",
    "moveNode": "node move",
    "moveNodes": "node moves",
    "createLink": "link created",
    "deleteFrame": "frame deleted",
    "deleteLink": "link deleted",
    "createNode": "node created"
  },
  "csv": {
    "noName": "no name",
    "name": "name",
    "address": "address",
    "kind": "type",
    "layer": "layer"
  },
  "import": {
    "title": "Import devices from CSV",
    "short": "Import from CSV",
    "intro": "Columns: name, address, type, layer. The separator is a comma or a semicolon. A header row, if present, is recognized on its own. An unknown type becomes “other”.",
    "layerFromColumn": "The layer comes from the fourth column; the import creates no new layers.",
    "layerFallback": "Rows without a known layer land on “{{name}}”; the import creates no new layers.",
    "parsed": "rows parsed: {{count}}",
    "notParsed": "not parsed: {{count}}",
    "problem": "line {{line}}: {{reason}} — {{text}}",
    "noAddress": "no address",
    "andMore": "…and {{count}} more",
    "created": "created {{done}} of {{total}}",
    "createNodes": "Create {{count}} nodes"
  },
  "discovery": {
    "title": "Find devices in a subnet",
    "buttonHint": "Find devices in a subnet: the agent scans it and offers what it found",
    "intro": "The site agent pings the subnet and reads the neighbor table. What it finds is shown as a list — only what you check lands on the map.",
    "targetLayer": "Nodes will land on layer “{{name}}”.",
    "subnet": "Subnet",
    "subnetExample": "for example 192.168.10.0/24",
    "addressCount": "{{count}} addresses will be scanned",
    "scanPorts": "Check typical ports",
    "scanPortsHint": "Check typical ports on hosts that answered: they tell a camera from a printer",
    "scan": "Scan",
    "running": "Scanning…",
    "scanFailed": "The scan failed",
    "createFailed": "Could not create the nodes",
    "nobodyAnswered": "Nobody answered in {{cidr}}. That is not always an empty network: devices can be set not to answer pings. Try enabling the typical port check or scan a neighboring subnet.",
    "found": "Found {{found}} of {{scanned}} scanned addresses",
    "selectNew": "check everything new",
    "clearSelection": "clear the checks",
    "ports": "Ports",
    "addAria": "Add {{ip}}",
    "answeredIcmp": "answered the ping",
    "foundByNeighbors": "found only in the neighbor table",
    "alreadyOnMap": "already on the map: {{name}}",
    "alreadyOnMapHint": "This address is already on the map",
    "nameAria": "Name for {{ip}}",
    "kindAria": "Type for {{ip}}",
    "progress": "Added {{done}} of {{total}}…",
    "addSelected": "Add the checked ones ({{count}})"
  },
  "perf": {
    "run": "Run for 6 seconds",
    "running": "Measuring…",
    "pass": "passes",
    "fail": "DOES NOT PASS",
    "nodes": "nodes {{count}}",
    "frames": "frames {{count}}",
    "p95": "p95 frame {{ms}} ms",
    "worst": "worst {{ms}} ms",
    "slow": "slow {{percent}} %",
    "nodesLabel": "nodes"
  }
}
